import {
  GET_END_POINT_DEFINITIONS,
  GET_END_POINT_DEFINITIONS_SUCCESS,
  ADD_END_POINT_DEFINITION,
  ADD_END_POINT_DEFINITION_SUCCESS,
  UPDATE_END_POINT_DEFINITION,
  UPDATE_END_POINT_DEFINITION_SUCCESS,
  DELETE_END_POINT_DEFINITION,
  DELETE_END_POINT_DEFINITION_SUCCESS,
  API_ERROR

} from "./actionTypes"




export const getEndPointDefinitions = () => ({
  type: GET_END_POINT_DEFINITIONS,
})

export const getEndPointDefinitionSuccess = record => ({
  type: GET_END_POINT_DEFINITIONS_SUCCESS,
  payload: record,
})

export const addEndPointDefinition = record => ({
  type: ADD_END_POINT_DEFINITION,
  payload: record,
})

export const addEndPointDefinitionSuccess = record => ({
  type: ADD_END_POINT_DEFINITION_SUCCESS,
  payload: record,
})


export const updateEndPointDefinition = record => ({
  type: UPDATE_END_POINT_DEFINITION,
  payload: record,
})

export const updateEndPointDefinitionSuccess = record => ({
  type: UPDATE_END_POINT_DEFINITION_SUCCESS,
  payload: record,
})


export const deleteEndPointDefinition = guid => ({
  type: DELETE_END_POINT_DEFINITION,
  payload: guid,
})

export const deleteEndPointDefinitionSuccess = guid => ({
  type: DELETE_END_POINT_DEFINITION_SUCCESS,
  payload: guid,
})

export const endPointDefinitionError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

